import { Grid } from "@mui/material";
import { FormikProps } from "formik";

import { FormikAutocompleteSelect } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocompleteSelect";
import { weekdayOptions } from "@/pages/system-settings/tabs/courts/vienna/components/CourtLabels.utils";
import { CourtFormType } from "@/pages/system-settings/tabs/courts/vienna/components/court-dialog/court-form-fields/CourtForm.types";
import { useTranslation } from "@/translations";

interface Props {
  formik: FormikProps<CourtFormType>;
  index: number;
}

export function WeekdayDayFields({ formik, index }: Props) {
  const { t } = useTranslation();
  const base = `courtDays.${index}` as const;

  return (
    <Grid size={3}>
      <FormikAutocompleteSelect
        formik={formik}
        path={`${base}.weekday`}
        label={t("settings.courts.gerichtstag.weekday")}
        options={weekdayOptions(t)}
      />
    </Grid>
  );
}
